import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext } from 'react';
interface DeviceModeProviderProps {
  children?: React.ReactNode;
  resetSelectedMobileTab?: () => void;
  isMobile: boolean;
}
type DeviceModeContextType = {
  isMobile: boolean;
  resetSelectedMobileTab?: () => void;
};
const DeviceModeContext = createContext<DeviceModeContextType>({
  isMobile: false
});
export const useDeviceMode = () => {
  return useContext(DeviceModeContext);
};
function DeviceModeProvider(t0) {
  const $ = _c(6);
  const {
    children,
    resetSelectedMobileTab,
    isMobile
  } = t0;
  let t1;
  if ($[0] !== isMobile || $[1] !== resetSelectedMobileTab) {
    t1 = {
      isMobile,
      resetSelectedMobileTab
    };
    $[0] = isMobile;
    $[1] = resetSelectedMobileTab;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <DeviceModeContext.Provider value={t1}>{children}</DeviceModeContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export default DeviceModeProvider;